export default __webpack_public_path__ + "static/media/icons-help.b81d849e.svg";